import { Box } from "@mui/material";
import { DotSeparatedList, Text, TextSkeleton } from "@src/appV2/redesign/system/ui-components";

import { QUICK_SIGN_TEXT_WITH_LIGHTING_EMOJI } from "../DocumentsPage/constants";
import { useGetQualificationsForRequirement } from "../useGetQualificationsForRequirement";
import { isRequirementInstantReview } from "../utils/isRequirementInstantReview";
import { useRequirementDetailsContext } from "./useRequirementDetailsContext";

export function DocumentDetailsMetadata() {
  const { requirement: workerRequirement } = useRequirementDetailsContext();
  const { qualifications } = workerRequirement;

  const { truncatedQualifications, isLoading } = useGetQualificationsForRequirement(qualifications);

  return isLoading ? (
    <TextSkeleton variant="body2" width="50%" />
  ) : (
    <Text inline variant="body2" sx={(theme) => ({ color: theme.palette.text.secondary })}>
      <DotSeparatedList>
        {truncatedQualifications}
        {isRequirementInstantReview(workerRequirement) && (
          <Box
            component="span"
            sx={{
              color: (theme) => theme.palette.success.main,
              verticalAlign: "baseline",
            }}
          >
            {QUICK_SIGN_TEXT_WITH_LIGHTING_EMOJI}
          </Box>
        )}
      </DotSeparatedList>
    </Text>
  );
}
